<template>
  <div class="minheight100" style="padding-bottom: 130px">
    <app-header v-if="appUser.isNative" back-type="back-app" :title="title"></app-header>
    <div class="receive-main">
      <div class="address-main" @click="setAddress">
        <div class="address-content" v-if="addressDetail">
          <div class="address-detail">
            <div class="name">
              {{ addressDetail.contactName }}
            </div>
            <div class="contact">
              {{ addressDetail.contactNo }}
            </div>
          </div>
          <div class="address-commit">
            {{ addressDetail.addressArea.split(' / ').join('') }}{{ addressDetail.addressDetail }}
          </div>
        </div>
        <div class="address-content" v-else>
          <div class="address-detail">
            <div class="name">填写地址信息</div>
          </div>
          <div class="address-commit">不包含港澳台和海外</div>
        </div>
        <Icon name="arrow" />
      </div>
      <div class="goods-list" v-if="goodsDetail">
        <div class="goods-img">
          <img :src="goodsDetail.realGoodsImage" alt="" />
        </div>
        <div class="goods-title">
          {{ goodsDetail.realGoodsName }}
        </div>
      </div>
      <div class="no-list" v-else>
        <img src="../../../images/integral/no_list.png" alt="" />
        <div class="commit">未查询到可领取的实物商品</div>
      </div>
      <div class="receive-footer">
        <div class="user-main" v-if="appUser">
          <img :src="appUser.avtarUrl" alt="" />
          <div class="user-detail">
            <div class="user-name">
              {{ appUser.nickName }}({{ appUser.mobileNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') }})
            </div>
            <div class="user-id">友邻少年ID：{{ appUser.userId }}</div>
          </div>
        </div>
        <div class="btn-common" :class="{ 'btn-disabled': !goodsDetail }" @click="updateAddress">领取到当前地址</div>
      </div>
    </div>
    <Popup v-model="show" class="border-message-popup address-popup">
      <div class="message-popup">
        <div class="title">请核对收货信息填写是否正确</div>
        <div class="address-popup" v-if="addressDetail">
          <div class="flexdiv">
            <div class="flex-item-left">收货人：</div>
            <div class="">{{ addressDetail.contactName }}</div>
          </div>
          <div class="flexdiv">
            <div class="flex-item-left">联系电话：</div>
            <div class="">{{ addressDetail.contactNo }}</div>
          </div>
          <div class="flexdiv">
            <div class="flex-item-left">收货地址：</div>
            <div class="flex-content">
              {{ addressDetail.addressArea.split(' / ').join('') }}{{ addressDetail.addressDetail }}
            </div>
          </div>
        </div>
        <div class="flexdiv btn">
          <div class="btn-common block btn-grey" style="margin-right: 12px" @click="show = false">去修改</div>
          <div class="btn-common block" @click="submitUpdate">确定</div>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
import Body from '@/mixins/body'
import { appUser } from '@/utils'
import { getDetail, updateAddress } from '@/api/modules/payment/receivePage'
const action = 'vipActivity'
// import cardAddress from '../../payment/order/components/confirm-pay/card-address.vue'
import { toLoginView } from '@/utils/init/env-init'
import { Toast, Popup, Icon } from 'vant'

export default {
  name: 'receivePage',
  mixins: [Body],
  components: { Icon, Popup },
  data() {
    return { title: '领取讲义', appUser, url: '', type: 0, addressDetail: null, goodsDetail: null, show: false }
  },
  computed: {},
  watch: {},
  created() {
    console.log(appUser, 'appUser')
    if (this.hasUser()) {
      this.getDetail()
    }
  },
  mounted() {},
  methods: {
    // 检查用户
    hasUser() {
      console.log(this.hasToken({ action }), 'hasToken')
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      this.getDetail()
    },
    getDetail() {
      getDetail({
        orderSn: this.$route.query.orderSn
      }).then(res => {
        console.log(res, 'res')
        this.goodsDetail = res
        let addressChecked = JSON.parse(localStorage.getItem('addressChecked')) || {}
        this.addressDetail = addressChecked[appUser.userId]
        if (!this.addressDetail && res && res.addressList) {
          let data = res.addressList.find(item => item.defaultMark === 1)
          this.addressDetail = data ? data : res.addressList[0]
        }
      })
    },
    setAddress() {
      this.$router.push({
        name: !this.addressDetail ? 'addressEdit' : 'addressListNew',
        query: { type: 'default' }
      })
    },
    updateAddress() {
      if (!this.goodsDetail) return
      if (!this.addressDetail) {
        Toast('请先填写地址信息')
        return
      }
      this.show = true
    },
    submitUpdate() {
      updateAddress({ orderSn: this.goodsDetail.orderSn, addressId: this.addressDetail.id })
        .then(res => {
          Toast('领取成功')
          this.show = false
          if (appUser.miniProgram) {
            webUni.webView.redirectTo({
              url: '/pages/rights_receive/app_add_headTeacher/app_add_headTeacher'
            })
          } else {
            this.getDetail()
          }
        })
        .catch(err => {
          Toast(err.message || '领取失败，请联系班主任')
          this.show = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.minheight100 {
  background: #f2f2f2;
}
.card-address {
  margin-bottom: 0.16rem;
}
.receive-footer {
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.24rem 0.32rem 0.64rem;
  .user-main {
    margin-bottom: 0.32rem;
    .user-detail {
      color: #000;
      .user-name {
        color: #000;
        font-size: 0.28rem;
        font-weight: 400;
        line-height: 1.5;
      }
    }
  }
}
.no-list {
  background: #fff;
  text-align: center;
  padding: 0.48rem 0 1.4rem;
  img {
    width: 4rem;
  }
  .commit {
    text-align: center;
    margin-top: 0.4rem;
  }
}
.goods-list {
  background: #fff;
  padding: 0.32rem;
  display: flex;
  .goods-img {
    width: 1.6rem;
    height: 1.6rem;
    margin-right: 0.24rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .goods-title {
    font-size: 0.32rem;
    font-weight: bold;
    line-height: 1.5;
  }
}
.address-main {
  background: #fff;
  padding: 0.32rem;
  display: flex;
  margin-bottom: 12px;
  align-items: center;
  border-radius: 0;
  color: #999;
  .address-content {
    flex: 1;
    .address-detail {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .name {
        font-size: 16px;
        font-weight: bold;
        margin-right: 16px;
        color: #000;
      }
    }
    .address-content-tip {
      font-size: 16px;
      font-weight: bold;
      color: #000;
    }
  }
}
.address-popup {
  .message-popup {
    min-width: 300px;
    .address-popup {
      margin-bottom: 24px;
      .flexdiv {
        border-bottom: 1px solid #ebebeb;
        padding: 12px 0px;
        justify-content: space-between;
        // align-items: center;
        line-height: 1.3;
        .flex-item-right {
          color: #666;
          width: 100px;
        }
        .flex-content {
          flex: 1;
        }
      }
    }
    .btn {
    }
  }
}
</style>
